import React from 'react';
import { createRef } from 'react';
import { searchLink } from '../../content/data';
type SearchFormProps = {
  className?: string;
  id: string;
  ifFocusableOnLoad?: boolean;
  toShowCopyOnFocus: boolean;
};

class SearchForm extends React.Component<SearchFormProps> {
  constructor(props: SearchFormProps) {
    super(props);
  }
  state = {
    toShowCopy: !this.props.toShowCopyOnFocus,
  };
  inp: any = createRef();

  componentDidMount(): void {
    if (this.props.ifFocusableOnLoad) {
      this.inp.current.focus();
    }
  }
  render() {
    const cl = this.props.className || '';
    return (
      <>
        <form
          className={`bg-white shadow ${cl}`}
          name="global-form"
          method="get"
          autoComplete="off"
          action={searchLink}
          spellCheck="false">
          <div className="input-group">
            <input
              ref={this.inp}
              onFocus={() => {
                if (this.props.toShowCopyOnFocus) {
                  this.setState(() => ({
                    toShowCopy: true,
                  }));
                }
              }}
              onBlur={() => {
                if (this.props.toShowCopyOnFocus) {
                  this.setState(() => ({
                    toShowCopy: false,
                  }));
                }
              }}
              type="text"
              autoFocus
              className="form-control border-end-0 border border-white"
              placeholder="Search"
            />
            <button
              className="btn ecs-font-icon-act-search border-0 text-secondary h5 mb-0 "
              type="submit"
              aria-label="Search"></button>
          </div>
        </form>
        {this.state.toShowCopy && (
          <p className="p-2 body-text-xs mb-0">
            Don't enter personal info like your SSN, email or phone number
          </p>
        )}
      </>
    );
  }
}

export default SearchForm;
